'use strict';

var React = require('react'),
    Alert = require('../organisms/Alert'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var EditorDisregardChangesAlert = React.createClass({
  mixins: [PureRenderMixin],

  render() {
    return (
      <Alert title='Don’t Save?'
             message='The changes you made will not be saved.'>
        <BtnGroup>
          <Button color='red'
                  size='large'
                  onClick={this.handleLeaveClick}>
            Don’t Save
          </Button>
          <Button size='large'
                  onClick={this.handleCancelClick}>
            Cancel
          </Button>
        </BtnGroup>
      </Alert>
    );
  },

  handleLeaveClick() {
    DraftActionCreators.cancelEditingStamp(true);
    AlertActionCreators.hideAlert();
  },

  handleCancelClick() {
    AlertActionCreators.hideAlert();
  }
});

module.exports = EditorDisregardChangesAlert;



/** WEBPACK FOOTER **
 ** ./alerts/EditorDisregardChangesAlert.jsx
 **/